<template>
  <nav
    class="navbar"
  >
    <slot />
  </nav>
</template>

<script>

export default {
  name: 'VNavBar',
};
</script>
